// extracted by mini-css-extract-plugin
export default {"root":"Progressbar_root__siHBy","progress":"Progressbar_progress__8DIKK"};